import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '@shared/shared.module';

//* components
import * as featureComponents from '../features';

const components = featureComponents.components;
const services = featureComponents.services;

const modules = [
  CommonModule,
  BrowserModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  HttpClientModule,
  SharedModule,
];

const features = {
  components,
  modules,
  services,
};

@NgModule({
  declarations: features.components,
  imports: features.modules,
  exports: features.components,
  providers: features.services,
})
export class FeaturesModule { }
